/* Cama Navideña — comportamientos de marca (vanilla JS) */
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.cn-reveal');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('cn-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('cn-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function initFaq() {
    document.querySelectorAll('.cn-faq__item').forEach(function (item) {
      var boton = item.querySelector('.cn-faq__pregunta');
      var respuesta = item.querySelector('.cn-faq__respuesta');
      if (!boton || !respuesta) return;
      boton.addEventListener('click', function () {
        var abierta = item.classList.contains('is-open');
        item.classList.toggle('is-open', !abierta);
        boton.setAttribute('aria-expanded', String(!abierta));
        respuesta.style.maxHeight = !abierta ? respuesta.scrollHeight + 'px' : '';
      });
    });
  }

  function initGaleriaProducto() {
    var galeria = document.querySelector('[data-cn-galeria]');
    if (!galeria) return;
    var principal = galeria.querySelector('[data-cn-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-cn-galeria-mini]');
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        if (!src || !principal) return;
        principal.src = src;
        minis.forEach(function (m) { m.classList.remove('is-activa'); });
        mini.classList.add('is-activa');
      });
    });
  }

  function initSelectorVariantes() {
    var form = document.querySelector('[data-cn-producto-form]');
    if (!form) return;
    var variantesInput = form.querySelector('[data-cn-variantes]');
    if (!variantesInput) return;

    var variantes;
    try { variantes = JSON.parse(variantesInput.textContent); } catch (e) { return; }

    var pills = form.querySelectorAll('.cn-pill[data-opcion-index]');
    var idInput = form.querySelector('input[name="id"]');
    var botonSubmit = form.querySelector('[data-cn-add-to-cart]');
    var precioEls = document.querySelectorAll('[data-cn-precio]');
    var seleccionEl = document.querySelector('[data-cn-seleccion]');
    var precioCompareEl = document.querySelector('[data-cn-precio-compare]');

    function opcionesSeleccionadas() {
      var seleccion = [];
      var indices = [];
      pills.forEach(function (p) { indices.push(parseInt(p.getAttribute('data-opcion-index'), 10)); });
      var maxIndex = Math.max.apply(null, indices.length ? indices : [0]);
      for (var i = 0; i <= maxIndex; i++) {
        var activo = form.querySelector('.cn-pill.is-selected[data-opcion-index="' + i + '"]');
        seleccion[i] = activo ? activo.getAttribute('data-valor') : null;
      }
      return seleccion;
    }

    function formatearDinero(centavos) {
      return (centavos / 100).toFixed(2).replace('.', ',') + ' €';
    }

    function actualizar() {
      var seleccion = opcionesSeleccionadas();
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;

      if (idInput) idInput.value = variante.id;

      seleccion.forEach(function (valor, i) {
        var rotulo = form.querySelector('[data-cn-valor-actual="' + i + '"]');
        if (rotulo && valor) rotulo.textContent = valor;
      });
      if (variante.media_id) {
        var miniVariante = document.querySelector('[data-cn-galeria-mini][data-media-id="' + variante.media_id + '"]');
        if (miniVariante && !miniVariante.classList.contains('is-activa')) miniVariante.click();
      }
      var heroImg = document.querySelector('[data-cn-hero-imagen]');
      if (heroImg && variante.image && heroImg.getAttribute('data-actual') !== variante.image) {
        heroImg.setAttribute('data-actual', variante.image);
        heroImg.src = variante.image;
      }
      precioEls.forEach(function (el) { el.textContent = formatearDinero(variante.price); });
      if (seleccionEl) seleccionEl.textContent = seleccion.filter(Boolean).join(' · ');

      pills.forEach(function (pill) {
        var precioPill = pill.querySelector('[data-cn-pill-precio]');
        if (!precioPill) return;
        var i = parseInt(pill.getAttribute('data-opcion-index'), 10);
        var valorPill = pill.getAttribute('data-valor');
        var candidata = variantes.find(function (v) {
          return v.options.every(function (opt, j) { return j === i ? opt === valorPill : opt === seleccion[j]; });
        });
        if (candidata) precioPill.textContent = formatearDinero(candidata.price);
      });

      if (precioCompareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioCompareEl.textContent = formatearDinero(variante.compare_at_price);
          precioCompareEl.hidden = false;
        } else {
          precioCompareEl.hidden = true;
        }
      }
      if (botonSubmit) {
        if (variante.available) {
          botonSubmit.removeAttribute('disabled');
          botonSubmit.textContent = (botonSubmit.getAttribute('data-texto-comprar') || 'Añadir al carrito') + ' · ' + formatearDinero(variante.price);
        } else {
          botonSubmit.setAttribute('disabled', 'disabled');
          botonSubmit.textContent = botonSubmit.getAttribute('data-texto-agotado') || 'Agotado';
        }
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.hasAttribute('disabled')) return;
        var idx = pill.getAttribute('data-opcion-index');
        form.querySelectorAll('.cn-pill[data-opcion-index="' + idx + '"]').forEach(function (p) {
          p.classList.remove('is-selected');
        });
        pill.classList.add('is-selected');
        actualizar();
      });
    });

    actualizar();
  }

  function initStickyMovil() {
    var sticky = document.querySelector('[data-cn-sticky-movil]');
    var referencia = document.querySelector('[data-cn-producto-form]');
    if (!sticky || !referencia) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    observer.observe(referencia);
    var stickyBoton = sticky.querySelector('[data-cn-sticky-comprar]');
    if (stickyBoton) {
      stickyBoton.addEventListener('click', function () {
        var botonReal = referencia.querySelector('[data-cn-add-to-cart]');
        if (botonReal) botonReal.click();
      });
    }
  }

  function initPack() {
    var form = document.querySelector('[data-cn-pack-form]');
    if (!form) return;
    var packV, baseV;
    try {
      packV = JSON.parse(form.querySelector('[data-cn-pack-variantes]').textContent);
      baseV = JSON.parse(form.querySelector('[data-cn-pack-base]').textContent);
    } catch (e) { return; }

    var orden = (form.getAttribute('data-orden') || 'S,M,L').split(',');
    var idInput = form.querySelector('[data-pack-id]');
    var boton = form.querySelector('[data-pack-boton]');
    var selEl = form.querySelector('[data-pack-seleccion]');
    var ahorroEl = form.querySelector('[data-pack-ahorro]');
    var normalEl = form.querySelector('[data-pack-normal]');
    var precioEl = form.querySelector('[data-pack-precio]');
    var textoBoton = boton.getAttribute('data-texto') || 'Añadir el pack';
    var tabla = document.querySelectorAll('[data-pack-fila]');
    var raiz = form.closest('.cn-pack') || document;

    function euros(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
    function valor(cama, tipo) {
      var el = form.querySelector('.cn-pill.is-selected[data-pack-cama="' + cama + '"][data-pack-tipo="' + tipo + '"]');
      return el ? el.getAttribute('data-valor') : '';
    }
    function letra(t) { return t.split(' ')[0]; }
    function unidad(estilo, talla) {
      return baseV.find(function (v) { return v.estilo === estilo && v.talla === talla; });
    }

    function actualizar() {
      var e1 = valor(1, 'estilo'), t1 = valor(1, 'talla'), e2 = valor(2, 'estilo'), t2 = valor(2, 'talla');
      var letras = [letra(t1), letra(t2)].sort(function (a, b) { return orden.indexOf(a) - orden.indexOf(b); });
      var combo = letras.join(' + ');
      var pv = packV.find(function (v) { return v.title === combo; });

      form.querySelector('[data-pack-prop="1-estilo"]').value = e1;
      form.querySelector('[data-pack-prop="1-talla"]').value = t1;
      form.querySelector('[data-pack-prop="2-estilo"]').value = e2;
      form.querySelector('[data-pack-prop="2-talla"]').value = t2;

      var u1 = unidad(e1, t1), u2 = unidad(e2, t2);
      [u1, u2].forEach(function (u, i) {
        var img = raiz.querySelector('[data-pack-img="' + (i + 1) + '"]');
        if (img && u && u.image) img.src = u.image;
      });

      selEl.textContent = 'Cama 1: ' + e1 + ' · ' + letra(t1) + '  —  Cama 2: ' + e2 + ' · ' + letra(t2);

      tabla.forEach(function (fila) {
        fila.classList.toggle('is-activa', pv && fila.getAttribute('data-pack-fila') === pv.title);
      });

      if (!pv) {
        boton.setAttribute('disabled', 'disabled');
        boton.textContent = 'No disponible';
        return;
      }
      idInput.value = pv.id;
      precioEl.textContent = euros(pv.price);
      if (pv.compare_at_price && pv.compare_at_price > pv.price) {
        normalEl.textContent = euros(pv.compare_at_price);
        normalEl.hidden = false;
        ahorroEl.textContent = 'Ahorras ' + euros(pv.compare_at_price - pv.price);
      } else {
        normalEl.hidden = true;
        ahorroEl.textContent = '';
      }

      var hayStock = pv.available && u1 && u1.available && u2 && u2.available;
      if (hayStock) {
        boton.removeAttribute('disabled');
        boton.textContent = textoBoton + ' · ' + euros(pv.price);
      } else {
        boton.setAttribute('disabled', 'disabled');
        boton.textContent = 'Combinación agotada';
      }
    }

    form.querySelectorAll('.cn-pill[data-pack-cama]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var cama = pill.getAttribute('data-pack-cama');
        var tipo = pill.getAttribute('data-pack-tipo');
        form.querySelectorAll('.cn-pill[data-pack-cama="' + cama + '"][data-pack-tipo="' + tipo + '"]').forEach(function (p) {
          p.classList.remove('is-selected');
        });
        pill.classList.add('is-selected');
        actualizar();
      });
    });
    actualizar();
  }

  function initParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-cn-parallax]'));
    if (!els.length) return;
    var ticking = false;
    function actualizar() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > vh + 100) return;
        var velocidad = parseFloat(el.getAttribute('data-cn-parallax')) || 0;
        var centro = rect.top + rect.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (-centro * velocidad).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(actualizar); }
    }, { passive: true });
    actualizar();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initParallax();
    initPack();
    initReveal();
    initFaq();
    initGaleriaProducto();
    initSelectorVariantes();
    initStickyMovil();
  });
})();
